import { Routes } from '@angular/router';

import { EspecializacaoComponent } from './especializacao.component';

export const ESPECIALIZACAO_ROUTER: Routes = [
    {
      path: 'especializacao',
      component: EspecializacaoComponent,
      data: {
        meta: {
          title: 'Especialização',
          description: 'Conheça os cursos de especialização da melhor Universidade do Maranhão',
        },
      },
    },
    // {
    //   matcher: EspecializacaoUrlMatcher,
    //   component: EspecializacaoComponent,
    //   data: {
    //     meta: {
    //       title: 'Especialização',
    //       description: 'Conheça os cursos de especialização da melhor Universidade do Maranhão',
    //     },
    //   },
    // },
    // {
    //   path: 'especializacao/:curso',
    //   component: CursoEspecializacaoComponent,
    //   data: {
    //     meta: {
    //       title: 'Especialização',
    //       description: 'Conheça os cursos de especialização da melhor Universidade do Maranhão',
    //     },
    //   },
    // },
  ];